import {Component, OnInit} from '@angular/core';
import {FreeCasesService} from "./free-cases.service";
import {IFreeCase} from "../../@modules/+search-user/user-content/services/interfaces/free-cases.interface";
import {MatTableDataSource} from "@angular/material/table";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-free-cases',
  templateUrl: './free-cases.component.html',
  styleUrls: ['./free-cases.component.scss']
})
export class FreeCasesComponent implements OnInit {

  public freeCaseColumns = ['id', 'name', 'freeCases', 'actions'];
  public dataSource: MatTableDataSource<IFreeCase> = new MatTableDataSource()

  constructor(private freeCasesService: FreeCasesService,
              public dialogRef: MatDialogRef<FreeCasesComponent>,) {
  }

  ngOnInit() {
    this.freeCasesService.getFreeCases().subscribe((freeCases: IFreeCase[]) => {
      this.dataSource.data = freeCases;
    })
  }

  selectFreeCase(item: IFreeCase): void {
    this.dialogRef.close(item);
  }
}
